import React, { useEffect, useState } from "react";
import { Box, Grid } from "@mui/material";
import { StriimTypography, StriimMessageBox } from "@striim/striim-ui-v2";
import styles from "./schema-creation-errors.styles";
import api from "../../../../../core/api/api";
import utils from "../../../../../core/utils";
import { formatMessage } from "../../../../../app/components/flow/designer/appErrors/appExceptions";
import xss from "xss";

type Props = {
    appId: string;
};
const AppProgressErrorBox: React.FunctionComponent<Props> = ({ appId }) => {
    const [errorMessage, setErrorMessage] = useState<string>(null);
    const [showMore, setShowMore] = useState<boolean>(false);
    useEffect(() => {
        (async () => {
            try {
                const appName = appId ? utils.getName(appId) : null;
                if (appName) {
                    const flowErrors = await api.getFlowErrors(appName);
                    if (flowErrors) {
                        const formattedMessage = formatMessage(JSON.parse(flowErrors)?.message, true);
                        setErrorMessage(formattedMessage);
                    } else {
                        setErrorMessage(null);
                    }
                } else {
                    setErrorMessage(null);
                }
            } catch (err) {
                console.log(err);
            }
        })();
    }, [appId]);
    if (!errorMessage) return;
    return (
        <Box sx={styles.errorBox}>
            <StriimMessageBox
                text={
                    <Grid>
                        <Box>
                            <StriimTypography
                                variant="body4"
                                sx={{ color: theme => theme.palette.greyscale[900], wordBreak: "break-word" }}
                                data-test-id="error-box-message"
                            >
                                <div
                                    className="error-content"
                                    dangerouslySetInnerHTML={{ __html: xss(errorMessage) }}
                                ></div>
                            </StriimTypography>
                        </Box>
                    </Grid>
                }
                type="ERROR"
            />
        </Box>
    );
};

export default AppProgressErrorBox;
